[
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126001,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126001",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.07,
		"Date_of_arrival": "2021-08-01T15:00:00",
		"Date_of_Extraction": "2021-08-01T15:00:00",
		"Date_of_Analysis": "2021-08-01T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,2 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": null,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2218.0,
		"woF_15_25": 1446.0,
		"woF_25_50": 1319.0,
		"woF_50_100": 482.0,
		"woF_100_150": 80.0,
		"woF_150_200": 24.0,
		"woF_200_400": 12.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 6.0,
		"woF_300_400": 6.0,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2218.0,
		"All_15_25": 1447.0,
		"All_25_50": 1329.0,
		"All_50_100": 504.0,
		"All_100_150": 102.0,
		"All_150_200": 27.0,
		"All_200_400": 19.0,
		"All_400_600": 2.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 1.0,
		"All_200_300": 11.0,
		"All_300_400": 8.0,
		"All_400_500": 2.0,
		"All_500_600": 0.0,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 22.0,
		"Met_15_25": 51.0,
		"Met_25_50": 111.0,
		"Met_50_100": 39.0,
		"Met_100_150": 12.0,
		"Met_150_200": 4.0,
		"Met_200_400": 5.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 2.0,
		"Met_300_400": 3.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": null,
		"woFNM_1W": null,
		"woFNM_2L": null,
		"woFNM_2W": null,
		"woFNM_3L": 301.0,
		"woFNM_3W": 49.0,
		"woFNM_4L": 248.0,
		"woFNM_4W": 168.0,
		"woFNM_5L": 247.0,
		"woFNM_5W": 50.0,
		"Met_1L": 342.0,
		"Met_1W": 103.0,
		"Met_2L": 334.0,
		"Met_2W": 98.0,
		"Met_3L": 324.0,
		"Met_3W": 120.0,
		"Met_4L": 238.0,
		"Met_4W": 68.0,
		"Met_5L": 210.0,
		"Met_5W": 43.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 1210.0,
		"All_weighted_sum": 2131.0,
		"Met_weighted_sum": 203.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126001,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 60.0,
		"nm_sum": 538.0,
		"sum_fibers": 58.0,
		"fibers_sum": 58.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126002,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126002",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.51,
		"Date_of_arrival": "2021-08-02T15:00:00",
		"Date_of_Extraction": "2021-08-02T15:00:00",
		"Date_of_Analysis": "2021-08-02T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,2 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": null,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2047.0,
		"woF_15_25": 1726.0,
		"woF_25_50": 1646.0,
		"woF_50_100": 517.0,
		"woF_100_150": 132.0,
		"woF_150_200": 53.0,
		"woF_200_400": 68.0,
		"woF_400_600": 16.0,
		"woF_600_1000": 6.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 42.0,
		"woF_300_400": 26.0,
		"woF_400_500": 14.0,
		"woF_500_600": 2.0,
		"woF_600_700": 6.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2047.0,
		"All_15_25": 1734.0,
		"All_25_50": 1653.0,
		"All_50_100": 535.0,
		"All_100_150": 145.0,
		"All_150_200": 59.0,
		"All_200_400": 77.0,
		"All_400_600": 21.0,
		"All_600_1000": 11.0,
		"All_gt_1000": 0.0,
		"All_200_300": 46.0,
		"All_300_400": 31.0,
		"All_400_500": 17.0,
		"All_500_600": 4.0,
		"All_600_700": 8.0,
		"All_700_800": 0.0,
		"All_800_900": 3.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 24.0,
		"Met_15_25": 79.0,
		"Met_25_50": 206.0,
		"Met_50_100": 97.0,
		"Met_100_150": 33.0,
		"Met_150_200": 21.0,
		"Met_200_400": 26.0,
		"Met_400_600": 9.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 14.0,
		"Met_300_400": 12.0,
		"Met_400_500": 8.0,
		"Met_500_600": 1.0,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": null,
		"woFNM_1W": null,
		"woFNM_2L": null,
		"woFNM_2W": null,
		"woFNM_3L": 639.0,
		"woFNM_3W": 129.0,
		"woFNM_4L": 626.0,
		"woFNM_4W": 130.0,
		"woFNM_5L": 625.0,
		"woFNM_5W": 126.0,
		"Met_1L": 631.0,
		"Met_1W": 147.0,
		"Met_2L": 525.0,
		"Met_2W": 155.0,
		"Met_3L": 460.0,
		"Met_3W": 125.0,
		"Met_4L": 459.0,
		"Met_4W": 149.0,
		"Met_5L": 456.0,
		"Met_5W": 89.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 4498.0,
		"All_weighted_sum": 5806.0,
		"Met_weighted_sum": 1554.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126002,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 187.0,
		"nm_sum": 605.0,
		"sum_fibers": 56.0,
		"fibers_sum": 56.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126003,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126003",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.09,
		"Date_of_arrival": "2021-08-03T15:00:00",
		"Date_of_Extraction": "2021-08-03T15:00:00",
		"Date_of_Analysis": "2021-08-03T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,2 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": null,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2981.0,
		"woF_15_25": 1857.0,
		"woF_25_50": 1475.0,
		"woF_50_100": 386.0,
		"woF_100_150": 42.0,
		"woF_150_200": 15.0,
		"woF_200_400": 9.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 8.0,
		"woF_300_400": 1.0,
		"woF_400_500": 2.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2981.0,
		"All_15_25": 1859.0,
		"All_25_50": 1504.0,
		"All_50_100": 418.0,
		"All_100_150": 53.0,
		"All_150_200": 17.0,
		"All_200_400": 21.0,
		"All_400_600": 4.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 0.0,
		"All_200_300": 17.0,
		"All_300_400": 4.0,
		"All_400_500": 3.0,
		"All_500_600": 1.0,
		"All_600_700": 2.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 16.0,
		"Met_15_25": 45.0,
		"Met_25_50": 93.0,
		"Met_50_100": 51.0,
		"Met_100_150": 12.0,
		"Met_150_200": 7.0,
		"Met_200_400": 7.0,
		"Met_400_600": 3.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 6.0,
		"Met_300_400": 1.0,
		"Met_400_500": 2.0,
		"Met_500_600": 1.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": null,
		"woFNM_1W": null,
		"woFNM_2L": null,
		"woFNM_2W": null,
		"woFNM_3L": 187.0,
		"woFNM_3W": 101.0,
		"woFNM_4L": 167.0,
		"woFNM_4W": 52.0,
		"woFNM_5L": 167.0,
		"woFNM_5W": 77.0,
		"Met_1L": 521.0,
		"Met_1W": 15.0,
		"Met_2L": 440.0,
		"Met_2W": 27.0,
		"Met_3L": 408.0,
		"Met_3W": 26.0,
		"Met_4L": 336.0,
		"Met_4W": 31.0,
		"Met_5L": 278.0,
		"Met_5W": 35.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 1025.0,
		"All_weighted_sum": 2095.0,
		"Met_weighted_sum": 466.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126003,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 80.0,
		"nm_sum": 375.0,
		"sum_fibers": 63.0,
		"fibers_sum": 63.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126004,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126004",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.1,
		"Date_of_arrival": "2021-08-04T15:00:00",
		"Date_of_Extraction": "2021-08-04T15:00:00",
		"Date_of_Analysis": "2021-08-04T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": null,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1920.0,
		"woF_15_25": 1105.0,
		"woF_25_50": 737.0,
		"woF_50_100": 224.0,
		"woF_100_150": 20.0,
		"woF_150_200": 5.0,
		"woF_200_400": 3.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1920.0,
		"All_15_25": 1111.0,
		"All_25_50": 749.0,
		"All_50_100": 249.0,
		"All_100_150": 40.0,
		"All_150_200": 9.0,
		"All_200_400": 6.0,
		"All_400_600": 1.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 3.0,
		"All_200_300": 5.0,
		"All_300_400": null,
		"All_400_500": 0.0,
		"All_500_600": 1.0,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 24.0,
		"Met_15_25": 43.0,
		"Met_25_50": 42.0,
		"Met_50_100": 20.0,
		"Met_100_150": 6.0,
		"Met_150_200": 2.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": null,
		"woFNM_1W": null,
		"woFNM_2L": null,
		"woFNM_2W": null,
		"woFNM_3L": 166.0,
		"woFNM_3W": 30.0,
		"woFNM_4L": 161.0,
		"woFNM_4W": 34.0,
		"woFNM_5L": 151.0,
		"woFNM_5W": 24.0,
		"Met_1L": 217.0,
		"Met_1W": 133.0,
		"Met_2L": 186.0,
		"Met_2W": 40.0,
		"Met_3L": 160.0,
		"Met_3W": 66.0,
		"Met_4L": 141.0,
		"Met_4W": 24.0,
		"Met_5L": 126.0,
		"Met_5W": 24.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 397.0,
		"All_weighted_sum": 2138.0,
		"Met_weighted_sum": 78.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126004,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 29.0,
		"nm_sum": 223.0,
		"sum_fibers": 58.0,
		"fibers_sum": 58.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126005,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126005",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.08,
		"Date_of_arrival": "2021-08-05T15:00:00",
		"Date_of_Extraction": "2021-08-05T15:00:00",
		"Date_of_Analysis": "2021-08-05T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": null,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2475.0,
		"woF_15_25": 1280.0,
		"woF_25_50": 922.0,
		"woF_50_100": 321.0,
		"woF_100_150": 35.0,
		"woF_150_200": 11.0,
		"woF_200_400": 9.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 4.0,
		"woF_300_400": 5.0,
		"woF_400_500": 2.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2475.0,
		"All_15_25": 1282.0,
		"All_25_50": 951.0,
		"All_50_100": 353.0,
		"All_100_150": 57.0,
		"All_150_200": 16.0,
		"All_200_400": 21.0,
		"All_400_600": 6.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 2.0,
		"All_200_300": 12.0,
		"All_300_400": 9.0,
		"All_400_500": 4.0,
		"All_500_600": 2.0,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 25.0,
		"Met_15_25": 36.0,
		"Met_25_50": 54.0,
		"Met_50_100": 34.0,
		"Met_100_150": 3.0,
		"Met_150_200": 1.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 1.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": null,
		"woFNM_1W": null,
		"woFNM_2L": null,
		"woFNM_2W": null,
		"woFNM_3L": 417.0,
		"woFNM_3W": 29.0,
		"woFNM_4L": 361.0,
		"woFNM_4W": 102.0,
		"woFNM_5L": 347.0,
		"woFNM_5W": 55.0,
		"Met_1L": 400.0,
		"Met_1W": 27.0,
		"Met_2L": 183.0,
		"Met_2W": 21.0,
		"Met_3L": 122.0,
		"Met_3W": 18.0,
		"Met_4L": 107.0,
		"Met_4W": 8.0,
		"Met_5L": 104.0,
		"Met_5W": 21.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 896.0,
		"All_weighted_sum": 2389.0,
		"Met_weighted_sum": 71.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126005,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 39.0,
		"nm_sum": 340.0,
		"sum_fibers": 77.0,
		"fibers_sum": 77.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126006,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126006",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-06T15:00:00",
		"Date_of_Extraction": "2021-08-06T15:00:00",
		"Date_of_Analysis": "2021-08-06T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": null,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2066.0,
		"woF_15_25": 1550.0,
		"woF_25_50": 1142.0,
		"woF_50_100": 305.0,
		"woF_100_150": 42.0,
		"woF_150_200": 14.0,
		"woF_200_400": 8.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 8.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2066.0,
		"All_15_25": 1554.0,
		"All_25_50": 1155.0,
		"All_50_100": 327.0,
		"All_100_150": 52.0,
		"All_150_200": 18.0,
		"All_200_400": 11.0,
		"All_400_600": 2.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 1.0,
		"All_200_300": 10.0,
		"All_300_400": 1.0,
		"All_400_500": 1.0,
		"All_500_600": 1.0,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 16.0,
		"Met_15_25": 49.0,
		"Met_25_50": 78.0,
		"Met_50_100": 42.0,
		"Met_100_150": 8.0,
		"Met_150_200": 4.0,
		"Met_200_400": 2.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 2.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": null,
		"woFNM_1W": null,
		"woFNM_2L": null,
		"woFNM_2W": null,
		"woFNM_3L": 213.0,
		"woFNM_3W": 43.0,
		"woFNM_4L": 210.0,
		"woFNM_4W": 41.0,
		"woFNM_5L": 205.0,
		"woFNM_5W": 39.0,
		"Met_1L": 274.0,
		"Met_1W": 20.0,
		"Met_2L": 267.0,
		"Met_2W": 68.0,
		"Met_3L": 199.0,
		"Met_3W": 93.0,
		"Met_4L": 197.0,
		"Met_4W": 27.0,
		"Met_5L": 155.0,
		"Met_5W": 23.0,
		"Fib_Fmax1_Fmax": null,
		"Fib_Fmax1_Lstr": null,
		"Fib_Fmax2_Fmax": null,
		"Fib_Fmax2_Lstr": null,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": null,
		"Fib_Stretched_Sum_um": null,
		"woF_weighted_sum": 727.0,
		"All_weighted_sum": 1977.0,
		"Met_weighted_sum": 142.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126006,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 56.0,
		"nm_sum": 313.0,
		"sum_fibers": 46.0,
		"fibers_sum": 46.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126007,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126007",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.1,
		"Date_of_arrival": "2021-08-07T15:00:00",
		"Date_of_Extraction": "2021-08-07T15:00:00",
		"Date_of_Analysis": "2021-08-07T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.09,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1557.0,
		"woF_15_25": 1056.0,
		"woF_25_50": 834.0,
		"woF_50_100": 279.0,
		"woF_100_150": 47.0,
		"woF_150_200": 2.0,
		"woF_200_400": 8.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 7.0,
		"woF_300_400": 1.0,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1557.0,
		"All_15_25": 1058.0,
		"All_25_50": 849.0,
		"All_50_100": 294.0,
		"All_100_150": 55.0,
		"All_150_200": 7.0,
		"All_200_400": 16.0,
		"All_400_600": 3.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 2.0,
		"All_200_300": 11.0,
		"All_300_400": 5.0,
		"All_400_500": 3.0,
		"All_500_600": 0.0,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 2.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 33.0,
		"Met_15_25": 70.0,
		"Met_25_50": 78.0,
		"Met_50_100": 45.0,
		"Met_100_150": 9.0,
		"Met_150_200": 1.0,
		"Met_200_400": 4.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 4.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 331.0,
		"woFNM_1W": 41.0,
		"woFNM_2L": 245.0,
		"woFNM_2W": 105.0,
		"woFNM_3L": 233.0,
		"woFNM_3W": 54.0,
		"woFNM_4L": 204.0,
		"woFNM_4W": 32.0,
		"woFNM_5L": 152.0,
		"woFNM_5W": 56.0,
		"Met_1L": 299.0,
		"Met_1W": 79.0,
		"Met_2L": 285.0,
		"Met_2W": 81.0,
		"Met_3L": 274.0,
		"Met_3W": 161.0,
		"Met_4L": 210.0,
		"Met_4W": 99.0,
		"Met_5L": 165.0,
		"Met_5W": 15.0,
		"Fib_Fmax1_Fmax": 2254.0,
		"Fib_Fmax1_Lstr": 2963.0,
		"Fib_Fmax2_Fmax": 1859.0,
		"Fib_Fmax2_Lstr": 1930.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 14958.0,
		"Fib_Stretched_Sum_um": 19453.0,
		"woF_weighted_sum": 613.0,
		"All_weighted_sum": 2401.0,
		"Met_weighted_sum": 154.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126007,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 59.0,
		"nm_sum": 277.0,
		"sum_fibers": 44.0,
		"fibers_sum": 44.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126008,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126008",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.14,
		"Date_of_arrival": "2021-08-08T15:00:00",
		"Date_of_Extraction": "2021-08-08T15:00:00",
		"Date_of_Analysis": "2021-08-08T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.14,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2033.0,
		"woF_15_25": 1474.0,
		"woF_25_50": 1169.0,
		"woF_50_100": 333.0,
		"woF_100_150": 63.0,
		"woF_150_200": 13.0,
		"woF_200_400": 18.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 13.0,
		"woF_300_400": 5.0,
		"woF_400_500": 1.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2033.0,
		"All_15_25": 1478.0,
		"All_25_50": 1181.0,
		"All_50_100": 354.0,
		"All_100_150": 73.0,
		"All_150_200": 23.0,
		"All_200_400": 36.0,
		"All_400_600": 11.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 2.0,
		"All_200_300": 24.0,
		"All_300_400": 12.0,
		"All_400_500": 9.0,
		"All_500_600": 2.0,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 16.0,
		"Met_15_25": 30.0,
		"Met_25_50": 54.0,
		"Met_50_100": 32.0,
		"Met_100_150": 11.0,
		"Met_150_200": 6.0,
		"Met_200_400": 8.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 5.0,
		"Met_300_400": 3.0,
		"Met_400_500": 1.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 354.0,
		"woFNM_1W": 126.0,
		"woFNM_2L": 333.0,
		"woFNM_2W": 36.0,
		"woFNM_3L": 289.0,
		"woFNM_3W": 115.0,
		"woFNM_4L": 244.0,
		"woFNM_4W": 77.0,
		"woFNM_5L": 232.0,
		"woFNM_5W": 62.0,
		"Met_1L": 415.0,
		"Met_1W": 75.0,
		"Met_2L": 381.0,
		"Met_2W": 102.0,
		"Met_3L": 326.0,
		"Met_3W": 120.0,
		"Met_4L": 309.0,
		"Met_4W": 128.0,
		"Met_5L": 299.0,
		"Met_5W": 75.0,
		"Fib_Fmax1_Fmax": 2624.0,
		"Fib_Fmax1_Lstr": 3850.0,
		"Fib_Fmax2_Fmax": 1611.0,
		"Fib_Fmax2_Lstr": 2031.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 20861.0,
		"Fib_Stretched_Sum_um": 25775.0,
		"woF_weighted_sum": 1054.0,
		"All_weighted_sum": 3221.0,
		"Met_weighted_sum": 322.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126008,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 58.0,
		"nm_sum": 370.0,
		"sum_fibers": 73.0,
		"fibers_sum": 73.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126009,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126009",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.03,
		"Date_of_arrival": "2021-08-09T15:00:00",
		"Date_of_Extraction": "2021-08-09T15:00:00",
		"Date_of_Analysis": "2021-08-09T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.08,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 858.0,
		"woF_15_25": 696.0,
		"woF_25_50": 694.0,
		"woF_50_100": 242.0,
		"woF_100_150": 49.0,
		"woF_150_200": 8.0,
		"woF_200_400": 3.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 2.0,
		"woF_300_400": 1.0,
		"woF_400_500": 1.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 858.0,
		"All_15_25": 700.0,
		"All_25_50": 704.0,
		"All_50_100": 265.0,
		"All_100_150": 60.0,
		"All_150_200": 11.0,
		"All_200_400": 12.0,
		"All_400_600": 5.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 2.0,
		"All_200_300": 8.0,
		"All_300_400": 4.0,
		"All_400_500": 4.0,
		"All_500_600": 1.0,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 9.0,
		"Met_15_25": 22.0,
		"Met_25_50": 59.0,
		"Met_50_100": 16.0,
		"Met_100_150": 3.0,
		"Met_150_200": 2.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 564.0,
		"woFNM_1W": 158.0,
		"woFNM_2L": 474.0,
		"woFNM_2W": 161.0,
		"woFNM_3L": 365.0,
		"woFNM_3W": 79.0,
		"woFNM_4L": 240.0,
		"woFNM_4W": 38.0,
		"woFNM_5L": 207.0,
		"woFNM_5W": 68.0,
		"Met_1L": 160.0,
		"Met_1W": 60.0,
		"Met_2L": 157.0,
		"Met_2W": 45.0,
		"Met_3L": 145.0,
		"Met_3W": 39.0,
		"Met_4L": 138.0,
		"Met_4W": 58.0,
		"Met_5L": 109.0,
		"Met_5W": 15.0,
		"Fib_Fmax1_Fmax": 1710.0,
		"Fib_Fmax1_Lstr": 2300.0,
		"Fib_Fmax2_Fmax": 1645.0,
		"Fib_Fmax2_Lstr": 1778.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 11983.0,
		"Fib_Stretched_Sum_um": 14090.0,
		"woF_weighted_sum": 686.0,
		"All_weighted_sum": 2060.0,
		"Met_weighted_sum": 46.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126009,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 21.0,
		"nm_sum": 283.0,
		"sum_fibers": 52.0,
		"fibers_sum": 52.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126010,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126010",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.04,
		"Date_of_arrival": "2021-08-10T15:00:00",
		"Date_of_Extraction": "2021-08-10T15:00:00",
		"Date_of_Analysis": "2021-08-10T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.11,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2076.0,
		"woF_15_25": 1382.0,
		"woF_25_50": 1057.0,
		"woF_50_100": 267.0,
		"woF_100_150": 41.0,
		"woF_150_200": 13.0,
		"woF_200_400": 11.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 10.0,
		"woF_300_400": 1.0,
		"woF_400_500": 1.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2076.0,
		"All_15_25": 1386.0,
		"All_25_50": 1072.0,
		"All_50_100": 303.0,
		"All_100_150": 66.0,
		"All_150_200": 23.0,
		"All_200_400": 22.0,
		"All_400_600": 3.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 5.0,
		"All_200_300": 17.0,
		"All_300_400": 5.0,
		"All_400_500": 1.0,
		"All_500_600": 2.0,
		"All_600_700": 1.0,
		"All_700_800": 2.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 20.0,
		"Met_15_25": 43.0,
		"Met_25_50": 73.0,
		"Met_50_100": 29.0,
		"Met_100_150": 7.0,
		"Met_150_200": 2.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 1.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 810.0,
		"woFNM_1W": 86.0,
		"woFNM_2L": 707.0,
		"woFNM_2W": 122.0,
		"woFNM_3L": 498.0,
		"woFNM_3W": 149.0,
		"woFNM_4L": 307.0,
		"woFNM_4W": 61.0,
		"woFNM_5L": 284.0,
		"woFNM_5W": 30.0,
		"Met_1L": 245.0,
		"Met_1W": 23.0,
		"Met_2L": 193.0,
		"Met_2W": 77.0,
		"Met_3L": 172.0,
		"Met_3W": 49.0,
		"Met_4L": 138.0,
		"Met_4W": 11.0,
		"Met_5L": 135.0,
		"Met_5W": 28.0,
		"Fib_Fmax1_Fmax": 2030.0,
		"Fib_Fmax1_Lstr": 2432.0,
		"Fib_Fmax2_Fmax": 2028.0,
		"Fib_Fmax2_Lstr": 2346.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 22833.0,
		"Fib_Stretched_Sum_um": 26870.0,
		"woF_weighted_sum": 1076.0,
		"All_weighted_sum": 4038.0,
		"Met_weighted_sum": 91.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126010,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 39.0,
		"nm_sum": 296.0,
		"sum_fibers": 90.0,
		"fibers_sum": 90.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126011,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126011",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.18,
		"Date_of_arrival": "2021-08-11T15:00:00",
		"Date_of_Extraction": "2021-08-11T15:00:00",
		"Date_of_Analysis": "2021-08-11T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.196508,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 3454.0,
		"woF_15_25": 3132.0,
		"woF_25_50": 2505.0,
		"woF_50_100": 734.0,
		"woF_100_150": 128.0,
		"woF_150_200": 18.0,
		"woF_200_400": 27.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 24.0,
		"woF_300_400": 3.0,
		"woF_400_500": 3.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 3454.0,
		"All_15_25": 3140.0,
		"All_25_50": 2531.0,
		"All_50_100": 803.0,
		"All_100_150": 193.0,
		"All_150_200": 41.0,
		"All_200_400": 29.0,
		"All_400_600": 4.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 26.0,
		"All_300_400": 3.0,
		"All_400_500": 4.0,
		"All_500_600": 0.0,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 22.0,
		"Met_15_25": 36.0,
		"Met_25_50": 59.0,
		"Met_50_100": 22.0,
		"Met_100_150": 5.0,
		"Met_150_200": 4.0,
		"Met_200_400": 2.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 2.0,
		"Met_300_400": 0.0,
		"Met_400_500": 2.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 470.0,
		"woFNM_1W": 51.0,
		"woFNM_2L": 369.0,
		"woFNM_2W": 46.0,
		"woFNM_3L": 349.0,
		"woFNM_3W": 36.0,
		"woFNM_4L": 341.0,
		"woFNM_4W": 64.0,
		"woFNM_5L": 282.0,
		"woFNM_5W": 117.0,
		"Met_1L": 458.0,
		"Met_1W": 66.0,
		"Met_2L": 406.0,
		"Met_2W": 82.0,
		"Met_3L": 296.0,
		"Met_3W": 79.0,
		"Met_4L": 262.0,
		"Met_4W": 36.0,
		"Met_5L": 181.0,
		"Met_5W": 45.0,
		"Fib_Fmax1_Fmax": 451.0,
		"Fib_Fmax1_Lstr": 503.0,
		"Fib_Fmax2_Fmax": 228.0,
		"Fib_Fmax2_Lstr": 232.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 19490.0,
		"Fib_Stretched_Sum_um": 19766.0,
		"woF_weighted_sum": 2032.0,
		"All_weighted_sum": 2664.0,
		"Met_weighted_sum": 238.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126011,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 35.0,
		"nm_sum": 875.0,
		"sum_fibers": 160.0,
		"fibers_sum": 160.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126012,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126012",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.11,
		"Date_of_arrival": "2021-08-12T15:00:00",
		"Date_of_Extraction": "2021-08-12T15:00:00",
		"Date_of_Analysis": "2021-08-12T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.13004,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1861.0,
		"woF_15_25": 1412.0,
		"woF_25_50": 1290.0,
		"woF_50_100": 474.0,
		"woF_100_150": 108.0,
		"woF_150_200": 29.0,
		"woF_200_400": 20.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 18.0,
		"woF_300_400": 2.0,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1861.0,
		"All_15_25": 1412.0,
		"All_25_50": 1306.0,
		"All_50_100": 535.0,
		"All_100_150": 173.0,
		"All_150_200": 54.0,
		"All_200_400": 28.0,
		"All_400_600": 3.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 24.0,
		"All_300_400": 4.0,
		"All_400_500": 2.0,
		"All_500_600": 1.0,
		"All_600_700": 2.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 12.0,
		"Met_15_25": 35.0,
		"Met_25_50": 49.0,
		"Met_50_100": 41.0,
		"Met_100_150": 11.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 318.0,
		"woFNM_1W": 36.0,
		"woFNM_2L": 312.0,
		"woFNM_2W": 39.0,
		"woFNM_3L": 274.0,
		"woFNM_3W": 47.0,
		"woFNM_4L": 259.0,
		"woFNM_4W": 30.0,
		"woFNM_5L": 242.0,
		"woFNM_5W": 27.0,
		"Met_1L": 164.0,
		"Met_1W": 13.0,
		"Met_2L": 141.0,
		"Met_2W": 45.0,
		"Met_3L": 117.0,
		"Met_3W": 94.0,
		"Met_4L": 116.0,
		"Met_4W": 56.0,
		"Met_5L": 113.0,
		"Met_5W": 10.0,
		"Fib_Fmax1_Fmax": 2368.0,
		"Fib_Fmax1_Lstr": 4764.0,
		"Fib_Fmax2_Fmax": 666.0,
		"Fib_Fmax2_Lstr": 715.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 24796.0,
		"Fib_Stretched_Sum_um": 28119.0,
		"woF_weighted_sum": 1487.0,
		"All_weighted_sum": 3041.0,
		"Met_weighted_sum": 94.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126012,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 53.0,
		"nm_sum": 578.0,
		"sum_fibers": 164.0,
		"fibers_sum": 164.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126013,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126013",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-13T15:00:00",
		"Date_of_Extraction": "2021-08-13T15:00:00",
		"Date_of_Analysis": "2021-08-13T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,2 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.067661,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 844.0,
		"woF_15_25": 653.0,
		"woF_25_50": 650.0,
		"woF_50_100": 261.0,
		"woF_100_150": 34.0,
		"woF_150_200": 11.0,
		"woF_200_400": 8.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 7.0,
		"woF_300_400": 1.0,
		"woF_400_500": 1.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 844.0,
		"All_15_25": 654.0,
		"All_25_50": 656.0,
		"All_50_100": 275.0,
		"All_100_150": 49.0,
		"All_150_200": 18.0,
		"All_200_400": 12.0,
		"All_400_600": 3.0,
		"All_600_1000": 7.0,
		"All_gt_1000": 0.0,
		"All_200_300": 9.0,
		"All_300_400": 3.0,
		"All_400_500": 1.0,
		"All_500_600": 2.0,
		"All_600_700": 2.0,
		"All_700_800": 2.0,
		"All_800_900": 2.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 7.0,
		"Met_15_25": 18.0,
		"Met_25_50": 40.0,
		"Met_50_100": 18.0,
		"Met_100_150": 1.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 511.0,
		"woFNM_1W": 139.0,
		"woFNM_2L": 495.0,
		"woFNM_2W": 122.0,
		"woFNM_3L": 334.0,
		"woFNM_3W": 36.0,
		"woFNM_4L": 286.0,
		"woFNM_4W": 101.0,
		"woFNM_5L": 228.0,
		"woFNM_5W": 36.0,
		"Met_1L": 160.0,
		"Met_1W": 60.0,
		"Met_2L": 117.0,
		"Met_2W": 71.0,
		"Met_3L": 84.0,
		"Met_3W": 27.0,
		"Met_4L": 80.0,
		"Met_4W": 24.0,
		"Met_5L": 79.0,
		"Met_5W": 11.0,
		"Fib_Fmax1_Fmax": 964.0,
		"Fib_Fmax1_Lstr": 1051.0,
		"Fib_Fmax2_Fmax": 871.0,
		"Fib_Fmax2_Lstr": 1473.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 11318.0,
		"Fib_Stretched_Sum_um": 13564.0,
		"woF_weighted_sum": 752.0,
		"All_weighted_sum": 2025.0,
		"Met_weighted_sum": 31.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126013,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 20.0,
		"nm_sum": 296.0,
		"sum_fibers": 48.0,
		"fibers_sum": 48.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126014,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126014",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-14T15:00:00",
		"Date_of_Extraction": "2021-08-14T15:00:00",
		"Date_of_Analysis": "2021-08-14T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,2 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.109475,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1837.0,
		"woF_15_25": 1285.0,
		"woF_25_50": 1172.0,
		"woF_50_100": 404.0,
		"woF_100_150": 61.0,
		"woF_150_200": 13.0,
		"woF_200_400": 8.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 8.0,
		"woF_300_400": 0.0,
		"woF_400_500": 0.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1837.0,
		"All_15_25": 1292.0,
		"All_25_50": 1192.0,
		"All_50_100": 429.0,
		"All_100_150": 83.0,
		"All_150_200": 18.0,
		"All_200_400": 19.0,
		"All_400_600": 4.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 3.0,
		"All_200_300": 17.0,
		"All_300_400": 2.0,
		"All_400_500": 1.0,
		"All_500_600": 3.0,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 13.0,
		"Met_15_25": 25.0,
		"Met_25_50": 51.0,
		"Met_50_100": 24.0,
		"Met_100_150": 5.0,
		"Met_150_200": 5.0,
		"Met_200_400": 2.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 2.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 1.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 298.0,
		"woFNM_1W": 142.0,
		"woFNM_2L": 270.0,
		"woFNM_2W": 36.0,
		"woFNM_3L": 234.0,
		"woFNM_3W": 45.0,
		"woFNM_4L": 217.0,
		"woFNM_4W": 34.0,
		"woFNM_5L": 206.0,
		"woFNM_5W": 90.0,
		"Met_1L": 531.0,
		"Met_1W": 172.0,
		"Met_2L": 278.0,
		"Met_2W": 43.0,
		"Met_3L": 218.0,
		"Met_3W": 62.0,
		"Met_4L": 189.0,
		"Met_4W": 112.0,
		"Met_5L": 185.0,
		"Met_5W": 64.0,
		"Fib_Fmax1_Fmax": 2041.0,
		"Fib_Fmax1_Lstr": 2305.0,
		"Fib_Fmax2_Fmax": 2026.0,
		"Fib_Fmax2_Lstr": 2386.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 19000.0,
		"Fib_Stretched_Sum_um": 23846.0,
		"woF_weighted_sum": 957.0,
		"All_weighted_sum": 3259.0,
		"Met_weighted_sum": 185.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126014,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 37.0,
		"nm_sum": 450.0,
		"sum_fibers": 71.0,
		"fibers_sum": 71.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126015,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126015",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.19,
		"Date_of_arrival": "2021-08-15T15:00:00",
		"Date_of_Extraction": "2021-08-15T15:00:00",
		"Date_of_Analysis": "2021-08-15T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.154208,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1982.0,
		"woF_15_25": 1339.0,
		"woF_25_50": 1082.0,
		"woF_50_100": 467.0,
		"woF_100_150": 106.0,
		"woF_150_200": 28.0,
		"woF_200_400": 22.0,
		"woF_400_600": 5.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": null,
		"woF_300_400": null,
		"woF_400_500": null,
		"woF_500_600": null,
		"woF_600_700": null,
		"woF_700_800": null,
		"woF_800_900": null,
		"woF_900_1000": null,
		"woF_1000_1500": null,
		"woF_1500_2000": null,
		"woF_2000_2500": null,
		"woF_2500_3000": null,
		"woF_gt_3000": null,
		"All_5_15": 1982.0,
		"All_15_25": 1343.0,
		"All_25_50": 1091.0,
		"All_50_100": 502.0,
		"All_100_150": 129.0,
		"All_150_200": 34.0,
		"All_200_400": 31.0,
		"All_400_600": 11.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": null,
		"All_300_400": null,
		"All_400_500": null,
		"All_500_600": null,
		"All_600_700": null,
		"All_700_800": null,
		"All_800_900": null,
		"All_900_1000": null,
		"All_1000_1500": null,
		"All_1500_2000": null,
		"All_2000_2500": null,
		"All_2500_3000": null,
		"All_gt_3000": null,
		"Met_5_15": 16.0,
		"Met_15_25": 22.0,
		"Met_25_50": 51.0,
		"Met_50_100": 31.0,
		"Met_100_150": 19.0,
		"Met_150_200": 4.0,
		"Met_200_400": 3.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": null,
		"Met_300_400": null,
		"Met_400_500": null,
		"Met_500_600": null,
		"Met_600_700": null,
		"Met_700_800": null,
		"Met_800_900": null,
		"Met_900_1000": null,
		"Met_1000_1500": null,
		"Met_1500_2000": null,
		"Met_2000_2500": null,
		"Met_2500_3000": null,
		"Met_gt_3000": null,
		"woFNM_1L": 904.0,
		"woFNM_1W": 43.0,
		"woFNM_2L": 473.0,
		"woFNM_2W": 158.0,
		"woFNM_3L": 452.0,
		"woFNM_3W": 68.0,
		"woFNM_4L": 419.0,
		"woFNM_4W": 62.0,
		"woFNM_5L": 333.0,
		"woFNM_5W": 53.0,
		"Met_1L": 561.0,
		"Met_1W": 137.0,
		"Met_2L": 408.0,
		"Met_2W": 150.0,
		"Met_3L": 273.0,
		"Met_3W": 60.0,
		"Met_4L": 249.0,
		"Met_4W": 94.0,
		"Met_5L": 202.0,
		"Met_5W": 129.0,
		"Fib_Fmax1_Fmax": 4922.0,
		"Fib_Fmax1_Lstr": 6365.0,
		"Fib_Fmax2_Fmax": 1931.0,
		"Fib_Fmax2_Lstr": 2086.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 20946.0,
		"Fib_Stretched_Sum_um": 25935.0,
		"woF_weighted_sum": 1959.0,
		"All_weighted_sum": 3756.0,
		"Met_weighted_sum": 319.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126015,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 59.0,
		"nm_sum": 570.0,
		"sum_fibers": 81.0,
		"fibers_sum": 81.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126016,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126016",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.14,
		"Date_of_arrival": "2021-08-16T15:00:00",
		"Date_of_Extraction": "2021-08-16T15:00:00",
		"Date_of_Analysis": "2021-08-16T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.152347,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2348.0,
		"woF_15_25": 1685.0,
		"woF_25_50": 1329.0,
		"woF_50_100": 462.0,
		"woF_100_150": 95.0,
		"woF_150_200": 20.0,
		"woF_200_400": 9.0,
		"woF_400_600": 4.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 8.0,
		"woF_300_400": 1.0,
		"woF_400_500": 4.0,
		"woF_500_600": 0.0,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2348.0,
		"All_15_25": 1690.0,
		"All_25_50": 1342.0,
		"All_50_100": 476.0,
		"All_100_150": 110.0,
		"All_150_200": 25.0,
		"All_200_400": 15.0,
		"All_400_600": 10.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 1.0,
		"All_200_300": 12.0,
		"All_300_400": 3.0,
		"All_400_500": 9.0,
		"All_500_600": 1.0,
		"All_600_700": 3.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 22.0,
		"Met_15_25": 46.0,
		"Met_25_50": 99.0,
		"Met_50_100": 41.0,
		"Met_100_150": 14.0,
		"Met_150_200": 2.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 1.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 697.0,
		"woFNM_1W": 223.0,
		"woFNM_2L": 488.0,
		"woFNM_2W": 105.0,
		"woFNM_3L": 485.0,
		"woFNM_3W": 112.0,
		"woFNM_4L": 448.0,
		"woFNM_4W": 259.0,
		"woFNM_5L": 401.0,
		"woFNM_5W": 122.0,
		"Met_1L": 229.0,
		"Met_1W": 28.0,
		"Met_2L": 160.0,
		"Met_2W": 24.0,
		"Met_3L": 152.0,
		"Met_3W": 54.0,
		"Met_4L": 140.0,
		"Met_4W": 56.0,
		"Met_5L": 129.0,
		"Met_5W": 36.0,
		"Fib_Fmax1_Fmax": 1086.0,
		"Fib_Fmax1_Lstr": 1387.0,
		"Fib_Fmax2_Fmax": 802.0,
		"Fib_Fmax2_Lstr": 836.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 11873.0,
		"Fib_Stretched_Sum_um": 13405.0,
		"woF_weighted_sum": 1566.0,
		"All_weighted_sum": 2997.0,
		"Met_weighted_sum": 131.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126016,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 58.0,
		"nm_sum": 533.0,
		"sum_fibers": 50.0,
		"fibers_sum": 50.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126017,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126017",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.04,
		"Date_of_arrival": "2021-08-17T15:00:00",
		"Date_of_Extraction": "2021-08-17T15:00:00",
		"Date_of_Analysis": "2021-08-17T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.101072,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1858.0,
		"woF_15_25": 1221.0,
		"woF_25_50": 1019.0,
		"woF_50_100": 347.0,
		"woF_100_150": 64.0,
		"woF_150_200": 12.0,
		"woF_200_400": 9.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 5.0,
		"woF_300_400": 4.0,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1858.0,
		"All_15_25": 1228.0,
		"All_25_50": 1029.0,
		"All_50_100": 364.0,
		"All_100_150": 70.0,
		"All_150_200": 18.0,
		"All_200_400": 14.0,
		"All_400_600": 2.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 2.0,
		"All_200_300": 10.0,
		"All_300_400": 4.0,
		"All_400_500": 0.0,
		"All_500_600": 2.0,
		"All_600_700": 4.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 21.0,
		"Met_15_25": 27.0,
		"Met_25_50": 37.0,
		"Met_50_100": 20.0,
		"Met_100_150": 8.0,
		"Met_150_200": 2.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 384.0,
		"woFNM_1W": 103.0,
		"woFNM_2L": 376.0,
		"woFNM_2W": 142.0,
		"woFNM_3L": 346.0,
		"woFNM_3W": 96.0,
		"woFNM_4L": 344.0,
		"woFNM_4W": 73.0,
		"woFNM_5L": 242.0,
		"woFNM_5W": 92.0,
		"Met_1L": 160.0,
		"Met_1W": 49.0,
		"Met_2L": 159.0,
		"Met_2W": 45.0,
		"Met_3L": 133.0,
		"Met_3W": 15.0,
		"Met_4L": 133.0,
		"Met_4W": 83.0,
		"Met_5L": 122.0,
		"Met_5W": 96.0,
		"Fib_Fmax1_Fmax": 1753.0,
		"Fib_Fmax1_Lstr": 1930.0,
		"Fib_Fmax2_Fmax": 1048.0,
		"Fib_Fmax2_Lstr": 1357.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 11333.0,
		"Fib_Stretched_Sum_um": 12788.0,
		"woF_weighted_sum": 855.0,
		"All_weighted_sum": 2534.0,
		"Met_weighted_sum": 70.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126017,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 30.0,
		"nm_sum": 402.0,
		"sum_fibers": 42.0,
		"fibers_sum": 42.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126018,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126018",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.04,
		"Date_of_arrival": "2021-08-18T15:00:00",
		"Date_of_Extraction": "2021-08-18T15:00:00",
		"Date_of_Analysis": "2021-08-18T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.152834,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1600.0,
		"woF_15_25": 1118.0,
		"woF_25_50": 772.0,
		"woF_50_100": 277.0,
		"woF_100_150": 68.0,
		"woF_150_200": 29.0,
		"woF_200_400": 20.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 2.0,
		"woF_300_400": null,
		"woF_400_500": null,
		"woF_500_600": null,
		"woF_600_700": null,
		"woF_700_800": null,
		"woF_800_900": null,
		"woF_900_1000": null,
		"woF_1000_1500": null,
		"woF_1500_2000": null,
		"woF_2000_2500": null,
		"woF_2500_3000": null,
		"woF_gt_3000": null,
		"All_5_15": 1600.0,
		"All_15_25": 1119.0,
		"All_25_50": 777.0,
		"All_50_100": 286.0,
		"All_100_150": 75.0,
		"All_150_200": 34.0,
		"All_200_400": 24.0,
		"All_400_600": 4.0,
		"All_600_1000": 7.0,
		"All_gt_1000": 3.0,
		"All_200_300": 10.0,
		"All_300_400": null,
		"All_400_500": null,
		"All_500_600": null,
		"All_600_700": null,
		"All_700_800": null,
		"All_800_900": null,
		"All_900_1000": null,
		"All_1000_1500": null,
		"All_1500_2000": null,
		"All_2000_2500": null,
		"All_2500_3000": null,
		"All_gt_3000": null,
		"Met_5_15": 17.0,
		"Met_15_25": 28.0,
		"Met_25_50": 54.0,
		"Met_50_100": 21.0,
		"Met_100_150": 8.0,
		"Met_150_200": 2.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 2.0,
		"Met_300_400": null,
		"Met_400_500": null,
		"Met_500_600": null,
		"Met_600_700": null,
		"Met_700_800": null,
		"Met_800_900": null,
		"Met_900_1000": null,
		"Met_1000_1500": null,
		"Met_1500_2000": null,
		"Met_2000_2500": null,
		"Met_2500_3000": null,
		"Met_gt_3000": null,
		"woFNM_1L": 561.0,
		"woFNM_1W": 263.0,
		"woFNM_2L": 421.0,
		"woFNM_2W": 150.0,
		"woFNM_3L": 398.0,
		"woFNM_3W": 182.0,
		"woFNM_4L": 359.0,
		"woFNM_4W": 85.0,
		"woFNM_5L": 351.0,
		"woFNM_5W": 49.0,
		"Met_1L": 1579.0,
		"Met_1W": 308.0,
		"Met_2L": 644.0,
		"Met_2W": 186.0,
		"Met_3L": 283.0,
		"Met_3W": 175.0,
		"Met_4L": 185.0,
		"Met_4W": 126.0,
		"Met_5L": 151.0,
		"Met_5W": 83.0,
		"Fib_Fmax1_Fmax": 1427.0,
		"Fib_Fmax1_Lstr": 1973.0,
		"Fib_Fmax2_Fmax": 1140.0,
		"Fib_Fmax2_Lstr": 1867.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 11603.0,
		"Fib_Stretched_Sum_um": 14738.0,
		"woF_weighted_sum": 1802.0,
		"All_weighted_sum": 3740.0,
		"Met_weighted_sum": 631.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126018,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 33.0,
		"nm_sum": 364.0,
		"sum_fibers": 33.0,
		"fibers_sum": 33.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126019,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126019",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.19,
		"Date_of_arrival": "2021-08-19T15:00:00",
		"Date_of_Extraction": "2021-08-19T15:00:00",
		"Date_of_Analysis": "2021-08-19T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.178246,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2739.0,
		"woF_15_25": 1682.0,
		"woF_25_50": 1504.0,
		"woF_50_100": 560.0,
		"woF_100_150": 109.0,
		"woF_150_200": 40.0,
		"woF_200_400": 19.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 13.0,
		"woF_300_400": 6.0,
		"woF_400_500": 0.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2739.0,
		"All_15_25": 1686.0,
		"All_25_50": 1525.0,
		"All_50_100": 620.0,
		"All_100_150": 147.0,
		"All_150_200": 48.0,
		"All_200_400": 37.0,
		"All_400_600": 6.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 3.0,
		"All_200_300": 27.0,
		"All_300_400": 10.0,
		"All_400_500": 3.0,
		"All_500_600": 3.0,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 19.0,
		"Met_15_25": 19.0,
		"Met_25_50": 44.0,
		"Met_50_100": 17.0,
		"Met_100_150": 4.0,
		"Met_150_200": 3.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 1.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 507.0,
		"woFNM_1W": 58.0,
		"woFNM_2L": 380.0,
		"woFNM_2W": 62.0,
		"woFNM_3L": 356.0,
		"woFNM_3W": 47.0,
		"woFNM_4L": 340.0,
		"woFNM_4W": 88.0,
		"woFNM_5L": 336.0,
		"woFNM_5W": 62.0,
		"Met_1L": 343.0,
		"Met_1W": 128.0,
		"Met_2L": 176.0,
		"Met_2W": 35.0,
		"Met_3L": 173.0,
		"Met_3W": 28.0,
		"Met_4L": 165.0,
		"Met_4W": 147.0,
		"Met_5L": 115.0,
		"Met_5W": 99.0,
		"Fib_Fmax1_Fmax": 2063.0,
		"Fib_Fmax1_Lstr": 2353.0,
		"Fib_Fmax2_Fmax": 1782.0,
		"Fib_Fmax2_Lstr": 2067.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 25457.0,
		"Fib_Stretched_Sum_um": 30648.0,
		"woF_weighted_sum": 1724.0,
		"All_weighted_sum": 4104.0,
		"Met_weighted_sum": 76.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126019,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 25.0,
		"nm_sum": 704.0,
		"sum_fibers": 133.0,
		"fibers_sum": 133.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126020,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126020",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.05,
		"Date_of_arrival": "2021-08-20T15:00:00",
		"Date_of_Extraction": "2021-08-20T15:00:00",
		"Date_of_Analysis": "2021-08-20T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,2 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.112382,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1495.0,
		"woF_15_25": 939.0,
		"woF_25_50": 1019.0,
		"woF_50_100": 417.0,
		"woF_100_150": 63.0,
		"woF_150_200": 20.0,
		"woF_200_400": 18.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 1.0,
		"woF_300_400": null,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1495.0,
		"All_15_25": 942.0,
		"All_25_50": 1025.0,
		"All_50_100": 466.0,
		"All_100_150": 120.0,
		"All_150_200": 46.0,
		"All_200_400": 28.0,
		"All_400_600": 4.0,
		"All_600_1000": 6.0,
		"All_gt_1000": 2.0,
		"All_200_300": 8.0,
		"All_300_400": null,
		"All_400_500": 3.0,
		"All_500_600": 1.0,
		"All_600_700": 2.0,
		"All_700_800": 2.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 26.0,
		"Met_15_25": 18.0,
		"Met_25_50": 39.0,
		"Met_50_100": 15.0,
		"Met_100_150": 5.0,
		"Met_150_200": 5.0,
		"Met_200_400": 3.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 660.0,
		"woFNM_1W": 156.0,
		"woFNM_2L": 373.0,
		"woFNM_2W": 39.0,
		"woFNM_3L": 354.0,
		"woFNM_3W": 43.0,
		"woFNM_4L": 349.0,
		"woFNM_4W": 46.0,
		"woFNM_5L": 307.0,
		"woFNM_5W": 69.0,
		"Met_1L": 232.0,
		"Met_1W": 34.0,
		"Met_2L": 212.0,
		"Met_2W": 67.0,
		"Met_3L": 201.0,
		"Met_3W": 101.0,
		"Met_4L": 187.0,
		"Met_4W": 62.0,
		"Met_5L": 186.0,
		"Met_5W": 75.0,
		"Fib_Fmax1_Fmax": 1216.0,
		"Fib_Fmax1_Lstr": 2003.0,
		"Fib_Fmax2_Fmax": 1092.0,
		"Fib_Fmax2_Lstr": 1425.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 26273.0,
		"Fib_Stretched_Sum_um": 29577.0,
		"woF_weighted_sum": 1281.0,
		"All_weighted_sum": 3728.0,
		"Met_weighted_sum": 128.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126020,
		"Passed": "0",
		"zeichnr": "Getriebedichtung",
		"met_sum": 28.0,
		"nm_sum": 491.0,
		"sum_fibers": 153.0,
		"fibers_sum": 153.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126021,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126021",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.05,
		"Date_of_arrival": "2021-08-21T15:00:00",
		"Date_of_Extraction": "2021-08-21T15:00:00",
		"Date_of_Analysis": "2021-08-21T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,2 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.194991,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 8449.0,
		"woF_15_25": 7045.0,
		"woF_25_50": 1578.0,
		"woF_50_100": 129.0,
		"woF_100_150": 27.0,
		"woF_150_200": 5.0,
		"woF_200_400": 0.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": 0.0,
		"woF_400_500": 1.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8449.0,
		"All_15_25": 7046.0,
		"All_25_50": 1582.0,
		"All_50_100": 137.0,
		"All_100_150": 31.0,
		"All_150_200": 7.0,
		"All_200_400": 4.0,
		"All_400_600": 2.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 2.0,
		"All_300_400": 2.0,
		"All_400_500": 2.0,
		"All_500_600": 0.0,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 8.0,
		"Met_15_25": 12.0,
		"Met_25_50": 19.0,
		"Met_50_100": 9.0,
		"Met_100_150": 1.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 439.0,
		"woFNM_1W": 116.0,
		"woFNM_2L": 180.0,
		"woFNM_2W": 30.0,
		"woFNM_3L": 167.0,
		"woFNM_3W": 39.0,
		"woFNM_4L": 157.0,
		"woFNM_4W": 64.0,
		"woFNM_5L": 157.0,
		"woFNM_5W": 131.0,
		"Met_1L": 119.0,
		"Met_1W": 73.0,
		"Met_2L": 77.0,
		"Met_2W": 61.0,
		"Met_3L": 72.0,
		"Met_3W": 32.0,
		"Met_4L": 68.0,
		"Met_4W": 21.0,
		"Met_5L": 66.0,
		"Met_5W": 24.0,
		"Fib_Fmax1_Fmax": 458.0,
		"Fib_Fmax1_Lstr": 519.0,
		"Fib_Fmax2_Fmax": 369.0,
		"Fib_Fmax2_Lstr": 427.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 3377.0,
		"Fib_Stretched_Sum_um": 3783.0,
		"woF_weighted_sum": 346.0,
		"All_weighted_sum": 516.0,
		"Met_weighted_sum": 13.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126021,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 10.0,
		"nm_sum": 152.0,
		"sum_fibers": 19.0,
		"fibers_sum": 19.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126022,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126022",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.06,
		"Date_of_arrival": "2021-08-22T15:00:00",
		"Date_of_Extraction": "2021-08-22T15:00:00",
		"Date_of_Analysis": "2021-08-22T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.108233,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1326.0,
		"woF_15_25": 1015.0,
		"woF_25_50": 797.0,
		"woF_50_100": 278.0,
		"woF_100_150": 47.0,
		"woF_150_200": 15.0,
		"woF_200_400": 16.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 12.0,
		"woF_300_400": 4.0,
		"woF_400_500": 1.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1326.0,
		"All_15_25": 1016.0,
		"All_25_50": 805.0,
		"All_50_100": 306.0,
		"All_100_150": 56.0,
		"All_150_200": 24.0,
		"All_200_400": 20.0,
		"All_400_600": 3.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 1.0,
		"All_200_300": 14.0,
		"All_300_400": 6.0,
		"All_400_500": 2.0,
		"All_500_600": 1.0,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 9.0,
		"Met_15_25": 24.0,
		"Met_25_50": 34.0,
		"Met_50_100": 18.0,
		"Met_100_150": 7.0,
		"Met_150_200": 1.0,
		"Met_200_400": 5.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 4.0,
		"Met_300_400": 1.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 458.0,
		"woFNM_1W": 253.0,
		"woFNM_2L": 334.0,
		"woFNM_2W": 160.0,
		"woFNM_3L": 318.0,
		"woFNM_3W": 161.0,
		"woFNM_4L": 313.0,
		"woFNM_4W": 111.0,
		"woFNM_5L": 262.0,
		"woFNM_5W": 45.0,
		"Met_1L": 317.0,
		"Met_1W": 135.0,
		"Met_2L": 298.0,
		"Met_2W": 99.0,
		"Met_3L": 269.0,
		"Met_3W": 77.0,
		"Met_4L": 230.0,
		"Met_4W": 115.0,
		"Met_5L": 226.0,
		"Met_5W": 19.0,
		"Fib_Fmax1_Fmax": 1035.0,
		"Fib_Fmax1_Lstr": 1076.0,
		"Fib_Fmax2_Fmax": 970.0,
		"Fib_Fmax2_Lstr": 1003.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 9364.0,
		"Fib_Stretched_Sum_um": 10757.0,
		"woF_weighted_sum": 921.0,
		"All_weighted_sum": 1802.0,
		"Met_weighted_sum": 135.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126022,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 31.0,
		"nm_sum": 326.0,
		"sum_fibers": 54.0,
		"fibers_sum": 54.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126023,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126023",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.1,
		"Date_of_arrival": "2021-08-23T15:00:00",
		"Date_of_Extraction": "2021-08-23T15:00:00",
		"Date_of_Analysis": "2021-08-23T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.13648,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 2014.0,
		"woF_15_25": 1672.0,
		"woF_25_50": 1301.0,
		"woF_50_100": 465.0,
		"woF_100_150": 91.0,
		"woF_150_200": 18.0,
		"woF_200_400": 17.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 12.0,
		"woF_300_400": 5.0,
		"woF_400_500": 1.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2014.0,
		"All_15_25": 1674.0,
		"All_25_50": 1329.0,
		"All_50_100": 509.0,
		"All_100_150": 121.0,
		"All_150_200": 32.0,
		"All_200_400": 22.0,
		"All_400_600": 5.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 3.0,
		"All_200_300": 13.0,
		"All_300_400": 9.0,
		"All_400_500": 4.0,
		"All_500_600": 1.0,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 11.0,
		"Met_15_25": 35.0,
		"Met_25_50": 43.0,
		"Met_50_100": 28.0,
		"Met_100_150": 2.0,
		"Met_150_200": 0.0,
		"Met_200_400": 0.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 0.0,
		"Met_400_500": 1.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 397.0,
		"woFNM_1W": 100.0,
		"woFNM_2L": 370.0,
		"woFNM_2W": 82.0,
		"woFNM_3L": 351.0,
		"woFNM_3W": 54.0,
		"woFNM_4L": 347.0,
		"woFNM_4W": 109.0,
		"woFNM_5L": 346.0,
		"woFNM_5W": 56.0,
		"Met_1L": 474.0,
		"Met_1W": 122.0,
		"Met_2L": 125.0,
		"Met_2W": 24.0,
		"Met_3L": 104.0,
		"Met_3W": 66.0,
		"Met_4L": 94.0,
		"Met_4W": 27.0,
		"Met_5L": 85.0,
		"Met_5W": 55.0,
		"Fib_Fmax1_Fmax": 2096.0,
		"Fib_Fmax1_Lstr": 3231.0,
		"Fib_Fmax2_Fmax": 1270.0,
		"Fib_Fmax2_Lstr": 1295.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 20036.0,
		"Fib_Stretched_Sum_um": 22518.0,
		"woF_weighted_sum": 1327.0,
		"All_weighted_sum": 3441.0,
		"Met_weighted_sum": 100.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126023,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 31.0,
		"nm_sum": 561.0,
		"sum_fibers": 101.0,
		"fibers_sum": 101.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126024,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126024",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.13,
		"Date_of_arrival": "2021-08-24T15:00:00",
		"Date_of_Extraction": "2021-08-24T15:00:00",
		"Date_of_Analysis": "2021-08-24T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.151777,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1724.0,
		"woF_15_25": 1391.0,
		"woF_25_50": 1107.0,
		"woF_50_100": 511.0,
		"woF_100_150": 129.0,
		"woF_150_200": 37.0,
		"woF_200_400": 19.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 16.0,
		"woF_300_400": 3.0,
		"woF_400_500": 0.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1724.0,
		"All_15_25": 1401.0,
		"All_25_50": 1123.0,
		"All_50_100": 532.0,
		"All_100_150": 154.0,
		"All_150_200": 41.0,
		"All_200_400": 27.0,
		"All_400_600": 2.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 0.0,
		"All_200_300": 22.0,
		"All_300_400": 5.0,
		"All_400_500": 2.0,
		"All_500_600": 0.0,
		"All_600_700": 0.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 8.0,
		"Met_15_25": 14.0,
		"Met_25_50": 25.0,
		"Met_50_100": 22.0,
		"Met_100_150": 6.0,
		"Met_150_200": 2.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 1.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 396.0,
		"woFNM_1W": 54.0,
		"woFNM_2L": 389.0,
		"woFNM_2W": 190.0,
		"woFNM_3L": 365.0,
		"woFNM_3W": 49.0,
		"woFNM_4L": 291.0,
		"woFNM_4W": 175.0,
		"woFNM_5L": 277.0,
		"woFNM_5W": 81.0,
		"Met_1L": 220.0,
		"Met_1W": 169.0,
		"Met_2L": 192.0,
		"Met_2W": 169.0,
		"Met_3L": 152.0,
		"Met_3W": 28.0,
		"Met_4L": 133.0,
		"Met_4W": 36.0,
		"Met_5L": 132.0,
		"Met_5W": 104.0,
		"Fib_Fmax1_Fmax": 723.0,
		"Fib_Fmax1_Lstr": 989.0,
		"Fib_Fmax2_Fmax": 706.0,
		"Fib_Fmax2_Lstr": 1395.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 10573.0,
		"Fib_Stretched_Sum_um": 11874.0,
		"woF_weighted_sum": 1664.0,
		"All_weighted_sum": 2365.0,
		"Met_weighted_sum": 80.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126024,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 31.0,
		"nm_sum": 665.0,
		"sum_fibers": 62.0,
		"fibers_sum": 62.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Getriebedichtung",
		"betaufnr": 126025,
		"kdnr": 12345,
		"artnr": "5123435",
		"Analysis_No": "126025",
		"Parts_on_Filter": 4.0,
		"Component_Surface_Area_cm2": 254.0,
		"Weight_mg": 0.13,
		"Date_of_arrival": "2021-08-25T15:00:00",
		"Date_of_Extraction": "2021-08-25T15:00:00",
		"Date_of_Analysis": "2021-08-25T15:00:00",
		"Component": "Getriebedichtung",
		"Component_No": "XYZ",
		"Testing_Specification": "5123435",
		"customer_no": "12345",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "51178",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:2,1 μm/Pxl   Y:2,1 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.12175,
		"Fiber_Compactness_Criterion": 30.0,
		"Fiber_Length_Width_Criterion": 10.0,
		"Fiber_Stret_InCircle_criterion": null,
		"Fiber_max_InCircle_criterion": null,
		"woF_5_15": 1728.0,
		"woF_15_25": 1314.0,
		"woF_25_50": 1108.0,
		"woF_50_100": 399.0,
		"woF_100_150": 81.0,
		"woF_150_200": 19.0,
		"woF_200_400": 9.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 4.0,
		"woF_300_400": 5.0,
		"woF_400_500": 1.0,
		"woF_500_600": 0.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1728.0,
		"All_15_25": 1315.0,
		"All_25_50": 1116.0,
		"All_50_100": 417.0,
		"All_100_150": 90.0,
		"All_150_200": 22.0,
		"All_200_400": 11.0,
		"All_400_600": 5.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 1.0,
		"All_200_300": 6.0,
		"All_300_400": 5.0,
		"All_400_500": 2.0,
		"All_500_600": 3.0,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 12.0,
		"Met_15_25": 41.0,
		"Met_25_50": 49.0,
		"Met_50_100": 25.0,
		"Met_100_150": 6.0,
		"Met_150_200": 5.0,
		"Met_200_400": 2.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": 2.0,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 480.0,
		"woFNM_1W": 75.0,
		"woFNM_2L": 359.0,
		"woFNM_2W": 92.0,
		"woFNM_3L": 338.0,
		"woFNM_3W": 57.0,
		"woFNM_4L": 305.0,
		"woFNM_4W": 164.0,
		"woFNM_5L": 261.0,
		"woFNM_5W": 45.0,
		"Met_1L": 345.0,
		"Met_1W": 34.0,
		"Met_2L": 320.0,
		"Met_2W": 64.0,
		"Met_3L": 174.0,
		"Met_3W": 67.0,
		"Met_4L": 164.0,
		"Met_4W": 90.0,
		"Met_5L": 160.0,
		"Met_5W": 77.0,
		"Fib_Fmax1_Fmax": 1867.0,
		"Fib_Fmax1_Lstr": 1993.0,
		"Fib_Fmax2_Fmax": 920.0,
		"Fib_Fmax2_Lstr": 989.0,
		"Fib_Lstr1_Fmax": null,
		"Fib_Lstr1_Lstr": null,
		"Fib_Fmax_Sum_um": 11565.0,
		"Fib_Stretched_Sum_um": 13693.0,
		"woF_weighted_sum": 1102.0,
		"All_weighted_sum": 2591.0,
		"Met_weighted_sum": 126.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 126025,
		"Passed": "1",
		"zeichnr": "Getriebedichtung",
		"met_sum": 38.0,
		"nm_sum": 471.0,
		"sum_fibers": 42.0,
		"fibers_sum": 42.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	}
]
